import { Component, type ErrorInfo, type ReactNode } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import Button from './Button';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
    };

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }

    private handleReset = () => {
        this.setState({ hasError: false, error: null });
        window.location.reload();
    };

    public render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    padding: '20px',
                    textAlign: 'center',
                    backgroundColor: 'var(--color-background)',
                    color: 'var(--color-text)'
                }}>
                    <div style={{
                        color: '#EF4444',
                        marginBottom: '20px'
                    }}>
                        <AlertTriangle size={64} />
                    </div>
                    <h1 style={{ marginBottom: '10px' }}>Ops! Algo deu errado.</h1>
                    <p style={{ marginBottom: '20px', color: 'var(--color-text-light)' }}>
                        Desculpe, ocorreu um erro inesperado.
                        {this.state.error && <br />}
                        <span style={{ fontSize: '12px', opacity: 0.7 }}>
                            {this.state.error?.message}
                        </span>
                    </p>
                    <Button onClick={this.handleReset} variant="primary">
                        <RefreshCw size={18} />
                        Recarregar Página
                    </Button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
